export default function changeWeekendColors(primaryOpt, secondaryOpt){
  document.querySelectorAll('.weekend')
    .forEach(el => el.style.setProperty('color', primaryOpt));
  document.querySelectorAll('.days div:nth-child(7n + 6):not(.prev-date), .days div:nth-child(7n + 7):not(.prev-date)')
    .forEach(el => el.style.setProperty('color', secondaryOpt));
}